import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2de03b24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-wrap" }
const _hoisted_2 = { class: "board_table" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { rowspan: "3" }, "날짜"),
    /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, "X"),
    /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, "블루스카이"),
    /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, "구글"),
    /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, "네이버"),
    /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, "유튜브"),
    /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, "인스타그램"),
    /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, "전체")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "검색"),
    /*#__PURE__*/_createElementVNode("th", null, "검색 결과"),
    /*#__PURE__*/_createElementVNode("th", null, "검색"),
    /*#__PURE__*/_createElementVNode("th", null, "검색 결과"),
    /*#__PURE__*/_createElementVNode("th", null, "검색"),
    /*#__PURE__*/_createElementVNode("th", null, "검색 결과"),
    /*#__PURE__*/_createElementVNode("th", null, "검색"),
    /*#__PURE__*/_createElementVNode("th", null, "검색 결과"),
    /*#__PURE__*/_createElementVNode("th", null, "검색"),
    /*#__PURE__*/_createElementVNode("th", null, "검색 결과"),
    /*#__PURE__*/_createElementVNode("th", null, "검색"),
    /*#__PURE__*/_createElementVNode("th", null, "검색 결과"),
    /*#__PURE__*/_createElementVNode("th", null, "검색"),
    /*#__PURE__*/_createElementVNode("th", null, "검색 결과")
  ])
], -1))
const _hoisted_4 = ["textContent"]
const _hoisted_5 = ["textContent"]
const _hoisted_6 = ["textContent"]
const _hoisted_7 = ["textContent"]
const _hoisted_8 = ["textContent"]
const _hoisted_9 = ["textContent"]
const _hoisted_10 = ["textContent"]
const _hoisted_11 = ["textContent"]
const _hoisted_12 = ["textContent"]
const _hoisted_13 = ["textContent"]
const _hoisted_14 = ["textContent"]
const _hoisted_15 = ["textContent"]
const _hoisted_16 = ["textContent"]
const _hoisted_17 = ["textContent"]
const _hoisted_18 = ["textContent"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "총 계 (건)", -1))
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { colspan: 16 }
const _hoisted_22 = { class: "board_graph_list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Chart = _resolveComponent("Chart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _hoisted_3,
          (!$setup.props.loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.chartData, (value) => {
                    return (_openBlock(), _createElementBlock("tr", null, [
                      _createElementVNode("td", {
                        textContent: _toDisplayString($setup.chartDateFormat2(value.date))
                      }, null, 8, _hoisted_4),
                      _createElementVNode("td", {
                        textContent: _toDisplayString($setup.numberFormat(value.cntX))
                      }, null, 8, _hoisted_5),
                      _createElementVNode("td", {
                        textContent: _toDisplayString($setup.numberFormat(value.cntResultX))
                      }, null, 8, _hoisted_6),
                      _createElementVNode("td", {
                        textContent: _toDisplayString($setup.numberFormat(value.cntBluesky))
                      }, null, 8, _hoisted_7),
                      _createElementVNode("td", {
                        textContent: _toDisplayString($setup.numberFormat(value.cntResultBluesky))
                      }, null, 8, _hoisted_8),
                      _createElementVNode("td", {
                        textContent: _toDisplayString($setup.numberFormat(value.cntGoogle))
                      }, null, 8, _hoisted_9),
                      _createElementVNode("td", {
                        textContent: _toDisplayString($setup.numberFormat(value.cntResultGoogle))
                      }, null, 8, _hoisted_10),
                      _createElementVNode("td", {
                        textContent: _toDisplayString($setup.numberFormat(value.cntNaver))
                      }, null, 8, _hoisted_11),
                      _createElementVNode("td", {
                        textContent: _toDisplayString($setup.numberFormat(value.cntResultNaver))
                      }, null, 8, _hoisted_12),
                      _createElementVNode("td", {
                        textContent: _toDisplayString($setup.numberFormat(value.cntYoutube))
                      }, null, 8, _hoisted_13),
                      _createElementVNode("td", {
                        textContent: _toDisplayString($setup.numberFormat(value.cntResultYoutube))
                      }, null, 8, _hoisted_14),
                      _createElementVNode("td", {
                        textContent: _toDisplayString($setup.numberFormat(value.cntInstagram))
                      }, null, 8, _hoisted_15),
                      _createElementVNode("td", {
                        textContent: _toDisplayString($setup.numberFormat(value.cntResultInstagram))
                      }, null, 8, _hoisted_16),
                      _createElementVNode("td", {
                        textContent: _toDisplayString($setup.numberFormat(value.cntAll))
                      }, null, 8, _hoisted_17),
                      _createElementVNode("td", {
                        textContent: _toDisplayString($setup.numberFormat(value.cntResultAll))
                      }, null, 8, _hoisted_18)
                    ]))
                  }), 256))
                ]),
                _createElementVNode("tfoot", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_19,
                    _createElementVNode("td", null, _toDisplayString($setup.numberFormat($setup.totalRow.cntX)), 1),
                    _createElementVNode("td", null, _toDisplayString($setup.numberFormat($setup.totalRow.cntResultX)), 1),
                    _createElementVNode("td", null, _toDisplayString($setup.numberFormat($setup.totalRow.cntBluesky)), 1),
                    _createElementVNode("td", null, _toDisplayString($setup.numberFormat($setup.totalRow.cntResultBluesky)), 1),
                    _createElementVNode("td", null, _toDisplayString($setup.numberFormat($setup.totalRow.cntGoogle)), 1),
                    _createElementVNode("td", null, _toDisplayString($setup.numberFormat($setup.totalRow.cntResultGoogle)), 1),
                    _createElementVNode("td", null, _toDisplayString($setup.numberFormat($setup.totalRow.cntNaver)), 1),
                    _createElementVNode("td", null, _toDisplayString($setup.numberFormat($setup.totalRow.cntResultNaver)), 1),
                    _createElementVNode("td", null, _toDisplayString($setup.numberFormat($setup.totalRow.cntYoutube)), 1),
                    _createElementVNode("td", null, _toDisplayString($setup.numberFormat($setup.totalRow.cntResultYoutube)), 1),
                    _createElementVNode("td", null, _toDisplayString($setup.numberFormat($setup.totalRow.cntInstagram)), 1),
                    _createElementVNode("td", null, _toDisplayString($setup.numberFormat($setup.totalRow.cntResultInstagram)), 1),
                    _createElementVNode("td", null, _toDisplayString($setup.numberFormat($setup.totalRow.cntAll)), 1),
                    _createElementVNode("td", null, _toDisplayString($setup.numberFormat($setup.totalRow.cntResultAll)), 1)
                  ])
                ])
              ], 64))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_20, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_21, [
                    _createVNode(_component_Spinner)
                  ])
                ])
              ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.chartData, (data) => {
        return (_openBlock(), _createBlock(_component_Chart, {
          style: {"height":"400px"},
          defaultLayout: $setup.chartLayout,
          data: data
        }, null, 8, ["defaultLayout", "data"]))
      }), 256))
    ])
  ], 64))
}